import { Parse } from 'parse';

let signingIn;
async function editingSession() {
  if (Parse.User.current()) return;
  // Anonymous Parse identity preserves existing ownerId semantics without signup UI.
  if (!signingIn)
    signingIn = Parse.User.logInWith('anonymous', {
      authData: { id: window.crypto.randomUUID() },
    }).finally(() => {
      signingIn = null;
    });
  await signingIn;
}
export async function lifeTapCall(name, identifier, params = {}, edit = false) {
  if (edit) await editingSession();
  try {
    return await Parse.Cloud.run(name, { ...params, identifier });
  } catch (error) {
    if (error.code !== 209) throw error;
    // An expired token must not trap viewing or recovery in an error loop.
    // A fresh browser still needs pack recovery; this never transfers ownership.
    try {
      await Parse.User.logOut();
    } catch (logoutError) {
      // Parse clears local storage before trying to revoke the already-expired
      // session (or remove its anonymous user), which can itself return 209/101.
      if (![209, 101].includes(logoutError.code)) throw logoutError;
    }
    if (edit) await editingSession();
    return Parse.Cloud.run(name, { ...params, identifier });
  }
}
export async function uploadLifeTapPhoto(identifier, file) {
  if (file.size > 10 * 1024 * 1024)
    throw Error('Choose a photo smaller than 10 MB.');
  const contract = await lifeTapCall(
    'getLifeTapUploadUrl',
    identifier,
    { name: file.name, mimeType: file.type, sizeBytes: file.size },
    true
  );
  const response = await fetch(contract.uploadUrl, {
    method: 'PUT',
    headers: contract.uploadHeaders,
    body: file,
  });
  if (!response.ok)
    throw Error('Your photo could not upload. Choose it again to retry.');
  return {
    id: contract.asset.id,
    assetId: contract.asset.id,
    url: contract.asset.url,
    alt: file.name,
  };
}
